import FilterJsonMiddleware from '../helpers/filterJsonMiddleware';

export const menuItems = new FilterJsonMiddleware([

    //#region Standard Dashboard Routes.
    {
        id: 1,
        isLayout: true
    },
    {
        id: 2,
        label: "menuitems.statistics.text",
        icon: "bx bx-bar-chart-alt",
        link: "/statistics"
    },
    //#region Custom Dashboard Routes.

    //write your menue items hear.
    {
        id: 3,
        label: "menuitems.pankLoans.injouies.text",
        icon: "bx-file",
        link: "/pankLoans/injouies",
        permission:{
            filter: 'any',
            values: ['show_loan', 'show_details_loan']
        },
    },

    {
        id: 4,
        label: "menuitems.pankLoans.martyrs.text",
        icon: "bx-file",
        link: "/pankLoans/martyrs",
        permission:{
            filter: 'any',
            values: ['show_loan', 'show_details_loan']
        },
    },

    {
        id: 5,
        label: "menuitems.plotsOfLands.injouies.text",
        icon: "bx-file",
        link: "/plotsOfLand/injouies",
        permission:{
            filter: 'any',
            values: ['show_land', 'show_details_land']
        },
    },

    {
        id: 6,
        label: "menuitems.plotsOfLands.martyrs.text",
        icon: "bx-file",
        link: "/plotsOfLand/martyrs",
        permission:{
            filter: 'any',
            values: ['show_land', 'show_details_land']
        },
    },

    {
        id: 7,
        label: "menuitems.pilgrimage.sacrificers.text",
        icon: "bx-file",
        link: "/pilgrimage/sacrificers",
        permission:{
            filter: 'any',
            values: ['show_pilgrimage', 'show_details_pilgrimage']
        },
    },
    {
        id: 8,
        label: "menuitems.scholarShips.text",
        icon: "bx-file",
        link: "/scholar_ships",
        permission:{
            filter: 'any',
            values: ['show_scholarships', 'show_details_scholarships']
        },
    },
    {
        id: 9,
        label: "menuitems.housingUnits.martyrs.text",
        icon: "bx-file",
        link: "/housing-units/martyrs",
        permission:{
            filter: 'any',
            values: ['show_housingunits', 'show_details_housingunits']

        },
    },
    {
        id: 10,
        label: "menuitems.housingUnits.injuries.text",
        icon: "bx-file",
        link: "/housing-units/injuries",
        permission:{
            filter: 'any',
            values: ['show_housingunits', 'show_details_housingunits']

        },
    },
    {
        id: 11,
        label: "menuitems.housingUnits.employees.text",
        icon: "bx-file",
        link: "/housing-units/employees",
        permission:{
            filter: 'any',
            values: ['show_housingunits', 'show_details_housingunits']

        },
    },
    {
        id: 9,
        label: "menuitems.plotsOfLand2.martyrs.text",
        icon: "bx-file",
        link: "/plots-of-land-2/martyrs",
        permission:{
            filter: 'any',
            values: ['show_plotsofland', 'show_details_plotsofland']

        },
    },
    {
        id: 10,
        label: "menuitems.plotsOfLand2.injuries.text",
        icon: "bx-file",
        link: "/plots-of-land-2/injuries",
        permission:{
            filter: 'any',
            values: ['show_plotsofland', 'show_details_plotsofland']

        },
    },
    {
        id: 11,
        label: "menuitems.plotsOfLand2.employees.text",
        icon: "bx-file",
        link: "/plots-of-land-2/employees",
        permission:{
            filter: 'any',
            values: ['show_plotsofland', 'show_details_plotsofland']

        },
    },
    {
        id: 12,
        label: "menuitems.governmentLoans.martyrs.text",
        icon: "bx-file",
        link: "/government-loans/martyrs",
        permission:{
            filter: 'any',
            values: ['show_governmentloans', 'show_details_governmentloans']

        },
    },
    {
        id: 13,
        label: "menuitems.governmentLoans.injuries.text",
        icon: "bx-file",
        link: "/government-loans/injuries",
        permission:{
            filter: 'any',
            values: ['show_governmentloans', 'show_details_governmentloans']

        },
    },
    {
        id: 14,
        label: "menuitems.governmentLoans.employees.text",
        icon: "bx-file",
        link: "/government-loans/employees",
        permission:{
            filter: 'any',
            values: ['show_governmentloans', 'show_details_governmentloans']

        },
    },
    {
        id: 15,
        label: "menuitems.healthCard.martyrs.text",
        icon: "bx-file",
        link: "/health-card/martyrs",
        permission:{
            filter: 'any',
            values: ['show_healthcard', 'show_details_healthcard']

        },
    },
    {
        id: 16,
        label: "menuitems.booths.text",
        icon: "bx-store",
        link: "/booths",
        permission:{
            filter: 'any',
            values: ['show_booths']
        },
    },
    {
        id: 100,
        label: "menuitems.exportData.text",
        icon: "bx-file",
        link: "/exportData",
        permission:{
            filter: 'any',
            values: ['export_to_excel_loan', 'export_to_excel_land', 'export_to_excel_pilgrimage', 'export_to_excel_scholarships', 'export_to_excel_housingunits', 'export_to_excel_governmentloans', 'export_to_excel_booths']
        },
    },
    {
        id: 101,
        label: "menuitems.PrintId.text",
        icon: "bx-id-card",
        link: "/print_id",
        permission:{
            filter: 'any',
            values: ['show_beneficiary', 'print_beneficiary_card']
        },
    },
    {
        id: 102,
        label: "menuitems.admins.text",
        icon: "bxs-user-detail",
        link: "/admins",
        permission:{
            filter: 'any',
            values: ['show_admin', 'add_admin', 'edit_admin', 'delete_admin']
        },
    },
    {
        id: 103,
        label: "menuitems.account.text",
        icon: "bxs-lock",
        link: "/account"
    },
    {
        id: 104,
        label: "menuitems.log.text",
        icon: "bx-group",
        link: "/admins/log_activity",
        permission:{
            filter: 'any',
            values: ['show_logs']
        },
    },
    //#endregion
]).data

